/**
 * Session Recovery Utilities
 * Platform session corruption durumlarında recovery için utility fonksiyonlar
 */

/**
 * Corrupted session durumunda emergency cleanup
 * Bu fonksiyon şu durumlarda kullanılır:
 * - Session var ama accessToken/refreshToken yok
 * - JWT'de error flag var ve temizlenemiyor
 * - Refresh sırasında sonsuz döngü oluşuyor
 */
export const performEmergencySessionCleanup = async () => {
    console.warn('[SessionRecovery] Performing emergency session cleanup');
    
    try {
        await fetch('/api/platform-session/logout', {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', 'X-Turkwise-BFF': '1' },
            body: JSON.stringify({ scope: 'local' }),
        }).catch(() => undefined);
        
        // Browser'da ek temizlik (eğer varsa)
        if (typeof window !== 'undefined') {
            // localStorage temizle
            localStorage.removeItem('user_info');
            localStorage.removeItem('nextauth.message');
            
            // Tüm auth-related cookies'i temizle
            const cookies = document.cookie.split(';');
            cookies.forEach(cookie => {
                const eqPos = cookie.indexOf('=');
                const name = eqPos > -1 ? cookie.substr(0, eqPos).trim() : cookie.trim();
                if (name === 'turkwise-platform-session' || name === '__Host-turkwise-platform-session') {
                    document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;domain=${window.location.hostname}`;
                    document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/`;
                }
            });
            
            // Login sayfasına yönlendir
            window.location.href = '/login';
        }
        
        console.log('[SessionRecovery] Emergency cleanup completed');
        return true;
    } catch (error) {
        console.error('[SessionRecovery] Emergency cleanup failed:', error);
        // Son çare olarak hard redirect
        if (typeof window !== 'undefined') {
            window.location.href = '/login';
        }
        return false;
    }
};

/**
 * Session health check
 * Session'ın sağlıklı olup olmadığını kontrol eder
 */
export const isSessionHealthy = (session: { user?: unknown; expires?: string } | null | undefined): boolean => {
    if (!session) return false;
    
    // Temel session kontrolü
    if (!session.user) return false;
    
    // Expire kontrolü
    if (session.expires) {
        const expiryDate = new Date(session.expires);
        if (expiryDate.getTime() <= Date.now()) {
            return false;
        }
    }
    
    return true;
};
